import React from "react";

/**
 * Delete confirmation component for pattern (base image)
 * @param {Object} formData - The pattern data to delete
 * @param {Function} handleSubmit - Function to handle deletion
 * @param {Function} onDiscard - Function to cancel deletion
 */
export default function Delete({ formData, handleSubmit, onDiscard }) {
  return (
    <div className="container form-group text-center text-secondary col-sm-8 pt-5">
      <h3 className="row justify-content-md-center">
        Are you sure you want to delete this Base Image?{" "}
        <b>
          <u>{formData?.pattern_name || "Unknown"}</u>
        </b>
      </h3>

      <div className="mt-4">
        <button
          type="button"
          className="btn bg-orange form-btn"
          onClick={handleSubmit}
          aria-label="Confirm deletion"
        >
          Yes
        </button>
        &nbsp;
        <button
          type="button"
          className="btn btn-secondary form-btn mx-3"
          onClick={onDiscard}
          aria-label="Cancel deletion"
        >
          No
        </button>
      </div>
    </div>
  );
}
